import { type QueryClient } from '@tanstack/vue-query';

import { keys } from '../../keys';

export const handleInvitationSuccess
  = (queryClient: QueryClient) => () => queryClient
    .invalidateQueries({ queryKey: keys.invitations.invitations.queryKey });
